import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule }       from '../shared/shared.module';
import { TireconnectService } from './tireconnect.service';

@NgModule({
  imports: [
    SharedModule
  ],
  providers: [
    TireconnectService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class TireconnectModule {}
